import { Injectable } from '@angular/core';
import { AppConstants } from 'app/app.settings';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root',
})
export class SrmApiService {
    constructor(private apiService: ApiService, private appConstants: AppConstants) {}

    getSetting<T>(key: string): Observable<T> {
        return this.apiService
            .get(`${this.appConstants.SRM_API_URL}/masterdata/settings/${key}`)
            .pipe(catchError((err) => this.errorHandler(err)));
    }

    errorHandler(error) {
        if (error.status === 401 || error.status === 403) {
            console.log(error.error);
            return of(false);
        }
        return throwError(error.error);
    }
}
